export const PriceShow = (input, Precision = 0, isPercent = false) => {
  try {
    if(input) {
        if (isPercent) Precision = 4;
        const persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
        ];
        const arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
        ];
        input = input.toString();
        for (var i = 0; i < 10; i++) {
        input = input.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
        const isNegative = input.startsWith("-");
        const absoluteValue = input.replace(/-/g, "");
        if (Precision === 0) input = absoluteValue.replace(/[^\d]/g, "");
        else input = absoluteValue.replace(/[^\d.]/g, "");
        let [integerPart, decimalPart] = input.split(".");
        if (!isPercent) integerPart = Number(integerPart).toLocaleString();
        input =
        decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
        if (isNegative && input !== "") input = `-${input}`;
    }
    return input;
  } catch (err) {
    console.error('[catch error]', err)
  }
};
